import styled from 'styled-components';

export const Background = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: var(--colorBlack);
  opacity: 0.5;
  z-index: 99999;
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 80%;
  border-radius: 11px 11px 8px 8px;
  position: absolute;
  top: 64px;
  left: 50%;
  bottom: 76px;
  transform: translateX(-50%);
  z-index: 99999;
  background-color: var(--colorWhite);
`;

export const TopWrapper = styled.div``;

export const Header = styled.div`
  background-color: var(--colorBlueGray1000);
  padding: 16px 24px;
  border-radius: 8px 8px 0 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  svg {
    cursor: pointer;
    color: var(--colorBlueGray300);
    justify-self: end;
  }
`;

export const DropWrapper = styled.div`
  justify-self: center;
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: var(--colorWhite);
  margin-bottom: 4px;
`;

export const SubTitle = styled.div`
  font-size: 12px;
  color: var(--colorBlueGray200);
`;

export const SortBlock = styled.div`
  font-size: 14px;
  font-weight: 600;
  display: flex;
  justify-content: flex-end;
  padding: 32px 0 12px;
  background-color: var(--colorWhite);
`;

export const SortItem = styled.div<{ isDark?: boolean; withUnderline?: boolean }>`
  color: ${({ isDark }) => (isDark ? 'var(--colorBlueGray1200)' : 'var(--colorBlueGray700)')};
  text-decoration: ${({ withUnderline }) => (withUnderline ? 'underline' : 'none')};
  margin-right: 24px;
  cursor: ${({ isDark, withUnderline }) => (withUnderline || !isDark ? 'pointer' : 'auto')};
`;

export const ContentWrapper = styled.div`
  max-height: calc(100% - 200px);
  overflow-y: auto;
  padding: 12px 16px 160px;
  background-color: var(--colorWhite);
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  justify-items: center;

  @media (max-width: 1365px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const InsertButton = styled.div<{ isDisabled: boolean }>`
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  width: 384px;
  height: 80px;
  color: var(--colorWhite);
  font-size: 14px;
  font-weight: 600;
  padding: 27px 24px 29px;
  text-align: center;
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'auto')};
  background: ${({ isDisabled }) =>
    isDisabled
      ? 'linear-gradient(-180deg, rgb(139, 143, 147) 0%, rgb(102, 107, 113) 100%)'
      : 'linear-gradient(-180deg, rgb(22, 66, 190) 0%, rgb(23, 55, 146) 100%)'};
  border-radius: 8px;
  box-shadow: 0px 0px 15px -7px rgba(0, 0, 0, 0.32), 0px 0px 46px 8px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.24);
`;
